<template>
  <div>
    <gg-card>
      <v-card-title class="d-block text-left pb-0">
        <h3>Additional Information</h3>
        <p>{{ question }}</p>
      </v-card-title>
      <v-card-text class="text-center pt-0">
        <v-progress-circular
          v-if="loading.reasons"
          indeterminate
          width="2"
          size="64"
          color="primary"
        />
        <div v-else>
          <v-radio-group
            v-model="reason"
          >
            <v-radio v-for="reason in reasons"
                     :key="reason.id"
                     :label="reason.name"
                     :value="reason"
            ></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>
      <v-card-actions>
        <gg-btn secondary :loading="loading.cancel" @click="cancelCR">
          Cancel
        </gg-btn>
        <gg-btn :disabled="!reasonSelected" :loading="loading.requestOffer" @click="requestOffer">
          Next
        </gg-btn>
      </v-card-actions>
    </gg-card>

    <offer-modal
      :opened="dialog"
      @accepted="offerAccepted"
      @declined="offerDeclined"
      @close="dialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import crCloseMixin from '@/mixins/crClose'
import OfferModal from './OfferModal'

export default {
  name: 'AdditionalInformation',
  components: { OfferModal },
  mixins: [crCloseMixin],
  props: {
    additionalQuestion: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      reasons: [],
      reason: null,
      offer: '',
      question: '',
      dialog: false,
      loading: {
        reasons: true,
        requestOffer: false,
        cancel: false
      }
    }
  },
  computed: {
    ...mapGetters(['cr_id']),
    reasonSelected () {
      return !!this.reason?.id
    },
    showOffer () {
      return this.offer !== ''
    },
  },
  methods: {
    ...mapActions(['sendCRExtra', 'sendCRGuided', 'reportError']),
    async loadReasons () {
      try {
        const response = await this.sendCRExtra()

        const isReasons = !!response.reasons && !!response.reasons.length
        if (!isReasons) {
          this.$emit('next-step')
          return
        }
        this.question = response.question
        this.reasons.splice(0, 0, ...response.reasons)
        this.loading.reasons = false
      } catch (e) {
        this.loading.reasons = false
        this.reportError(e)
      }
    },
    async requestOffer () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) return

        this.loading.requestOffer = true

        const data = {
          cr_id: Number(this.cr_id),
          reason: Number(this.reason.id),
        }

        const response = await this.sendCRGuided(data)
        this.$emit('set-comment', {
          required: this.reason.comment_required,
          question: this.reason.comment_question
        })
        if (!response.offer) {
          this.$emit('next-step')
          return
        }
        this.offer = response.offer_msg
        this.loading.requestOffer = false
        this.dialog = true
      } catch (e) {
        this.loading.requestOffer = false
        this.reportError(e)
      }
    },
    async cancelCR () {
      try {
        this.loading.cancel = true
        await this.crClose()
        this.loading.cancel = false
      } catch (e) {
        this.loading.cancel = false
        this.reportError(e.resultmsg)
        return
      }
      this.$router.push({ name: 'dashboard' })
    },
    offerAccepted (response) {
      this.$emit('offer-accepted', {
        step: 4,
        tpl: 'cr_escalate',
        response
      })
      this.offer = ''
    },
    offerDeclined () {
      this.$emit('offer-declined')
      this.offer = ''
    }
  },
}
</script>
